export default __webpack_public_path__ + "static/media/revision.055a8fe6.png";